import {
    ClickElement,
    ClickText,
    GA4EventName,
    GA4FeatureCategory,
    trackAnalyticsEvent,
} from '@jsmdg/tracking';

async function trackShippingTextClicked(): Promise<void> {
    await window.yieldToMainThread();
    trackAnalyticsEvent({
        category: 'ProductDetail',
        action: 'TextClick',
        label: 'DeliveryOptionsAndCosts',
        eventData: {
            eventName: GA4EventName.ClickTextLink,
            feature_category: GA4FeatureCategory.ProductdetailBuybox,
            click_element: ClickElement.DeliveryCosts,
            click_text: ClickText.Shipping,
        },
    });
}

export { trackShippingTextClicked };
